import React from 'react';
import { ModelSelection } from '@model-selection/model-selection';

export const AddLayerForm = () => {
  return (
    <ModelSelection />
  );
};